export default "__VITE_ASSET__69e2143b__"